/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "DEFAULT_QA_STORY_MODE" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "ENABLE_AMP" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "FLATTEN_REPLIES" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "SITE_MODERATOR" | "VIEWER_COUNT" | "%future added value";
export type CommentContainer_settings = {
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_settings" | "ReportFlowContainer_settings" | "ReactionButtonContainer_settings" | "ReplyCommentFormContainer_settings" | "EditCommentFormContainer_settings" | "UserTagsContainer_settings" | "MediaSectionContainer_settings" | "UsernameWithPopoverContainer_settings">;
    readonly " $refType": "CommentContainer_settings";
};
export type CommentContainer_settings$data = CommentContainer_settings;
export type CommentContainer_settings$key = {
    readonly " $data"?: CommentContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlags",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CaretContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReportFlowContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReactionButtonContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyCommentFormContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditCommentFormContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MediaSectionContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UsernameWithPopoverContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '621c5f0c9ff767fb972aacf9eb65342a';
export default node;
